export default {
  unit: {
    input_hint: 'يمكنك التعبير عن إجابتك بوحدة أخرى'
  },
  errors: {
    conversionFailed: 'فشلت عملية التحويل. يرجى المحاولة باستخدام وحدة أخرى.'
  }
}
